/** Skeletons represent blocks of loading text. */
import {css, keyframes} from '@emotion/react'

const skeletonKeyframes = keyframes`
  0% {
    background: rgba(206, 217, 224, 0.2);
  }
  to {
    background: rgba(92, 112, 128, 0.2);
  }
`

const skeletonCss = css`
  animation: ${skeletonKeyframes} 1s linear infinite alternate;
  background: rgba(206, 217, 224, 0.2);
  border-radius: 2px;
  color: transparent;
`

interface SkeletonProps {
  width?: string
  height?: string
  className?: string
}

export default function Skeleton({width, height, className}: SkeletonProps): JSX.Element {
  const sizeCss = css`
    ${width ? `width: ${width};` : ''}
    ${height ? `height: ${height};` : ''}
  `
  return <div className={className} css={[sizeCss, skeletonCss]} />
}
